import React, { HTMLAttributes } from 'react';
import {
  View,
} from '@uncinc/react-drupal-core';
import {
  ImmutableEntity,
} from '@uncinc/react-drupal-core/types';

import './style.scss';
import { ParagraphPartnersHighlights as Type } from '../../../types/uncinc_profile/paragraphs';
import { WysiwygField } from '../../../components';

interface ParagraphPartnersHighlightsProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphPartnersHighlights: React.FC<ParagraphPartnersHighlightsProps> = ({ entity }) => {
  const paragraph = entity.toJS();
  const uuid = paragraph.uuid[0].value;
  const title = paragraph.field_title[0]?.value;
  const body = paragraph.field_body[0]?.value;

  return (
    <div id={uuid} className="ParagraphPartnersHighlights">
      {title && <h2>{title}</h2>}
      {body && (
        <WysiwygField
          html={body}
          classes="ParagraphPartnersHighlights__body"
        />
      )}
      <View
        id="partners"
        display="highlights"
      />
    </div>
  );
};

export default ParagraphPartnersHighlights;
